import type { FaireProductEntity } from "../../entity_types/product";

export const p_umjf55b5pm: FaireProductEntity = {
  token: "p_umjf55b5pm",
  type: "product",
  name: "S925 Sterling Silver Moissanite Stacking Ring",
  brandToken: "b_9a7m2r54fa",
  brandName: "Gioiellin - S925 Silver Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/c004d12814d63a53963db77e129c5abd0d347da4b2ed1ad707c7b76948f13e45.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd1d459d6f336ea35d13eb9215b82f83be79fa1fca934d463e696638bfad0eb5.jpeg",
    "https://cdn.faire.com/fastly/cf2ab1aa00ec3bd1053761c9dc34a7095ee06fe45a5ea987db8238fe09761332.jpeg",
    "https://cdn.faire.com/fastly/1574e53450a1f5d882f0fdb3b4d809c762519cb1810d1b978e6f81fa5d0c8836.jpeg",
    "https://cdn.faire.com/fastly/9b9e5a9285fcae1267bb68be74d43e3384baa50d2ec2bcc4909c0ffdd36e7191.jpeg",
  ],
  priceDollars: 19.4,
  description:
    '"-ID: GIO-MD-RI2403\n-Material: S925 Sterling Silver White Gold Plated\n-Stone(s): Cubic Zirconia\n-Size: 5, 6, 7, 8, 9 (Standard US Size)\n-Weight(s): 0.78g\n-Quality: Excellent\n-Lead Free, -Nickel Free"',
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:23.294Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
